export class ConfigColor {
    id: number;
    hex: string;
    nombre: string;
}